import AlertLogs from "./pages/AlertLogs";
import AlertSettings from "./pages/AlertSettings";
import SharedReports from "./pages/SharedReports";
import SMSSubscription from "./pages/SMSSubscription";

const alertRoutes = [
  {
    path: "alerts",
    element: <AlertSettings />,
  },
  {
    path: "alerts/logs",
    element: <AlertLogs />,
  },
  {
    path: "alerts/sms",
    element: <SMSSubscription />,
  },
  {
    path: "alerts/shared-reports",
    element: <SharedReports />,
  },
];

export default alertRoutes;
